import React, { useRef, useState, useCallback } from "react";

export const BeforeAfter = ({ before, after, label, testId = "before-after" }) => {
  const [pos, setPos] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setPos(pct);
  }, []);

  const onDown = (e) => {
    dragging.current = true;
    const cx = e.touches ? e.touches[0].clientX : e.clientX;
    update(cx);
  };
  const onMove = (e) => {
    if (!dragging.current) return;
    const cx = e.touches ? e.touches[0].clientX : e.clientX;
    update(cx);
  };
  const onUp = () => { dragging.current = false; };

  return (
    <div className="space-y-4">
      <div
        ref={containerRef}
        className="relative w-full aspect-[4/3] overflow-hidden bg-ink cursor-ew-resize select-none"
        onMouseDown={onDown}
        onMouseMove={onMove}
        onMouseUp={onUp}
        onMouseLeave={onUp}
        onTouchStart={onDown}
        onTouchMove={onMove}
        onTouchEnd={onUp}
        data-testid={testId}
      >
        <img src={before} alt="Before" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
        <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
          <img src={after} alt="After" className="absolute inset-0 w-full h-full object-cover" style={{ width: `${100 / (pos / 100)}%`, maxWidth: 'none' }} draggable={false} />
        </div>
        <div className="ba-handle" style={{ left: `${pos}%` }} />
        <div className="absolute top-4 left-4 text-[10px] tracking-[0.3em] uppercase text-white/80 bg-black/30 backdrop-blur px-3 py-1.5">Before</div>
        <div className="absolute top-4 right-4 text-[10px] tracking-[0.3em] uppercase text-white/80 bg-black/30 backdrop-blur px-3 py-1.5">After</div>
      </div>
      {label && <p className="text-xs tracking-[0.2em] uppercase text-ink/60">{label}</p>}
    </div>
  );
};
